export type Maybe<T> = T | undefined

export enum Language {
  German = "de",
  French = "fr",
  Italian = "it",
  Undefined = "undefined", // added because legacy social links have no language
}

export function isLanguage(language: string): language is Language {
  return language === "de" || language === "fr" || language === "it" || language === "undefined";
}

export interface DateRange {
  from: Date;
  to: Date;
}